import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=ba84142c"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"
import style0 from "./Tags.vue?vue&type=style&index=0&id=ba84142c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports